import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/NewsTicker.css";

const NewsTicker = ({ noticias }) => {
  const navigate = useNavigate();
  const items = [...noticias, ...noticias];

  return (
    <div className="ticker-wrapper">
      <span className="ticker-label">Últimas Noticias</span>
      <div className="ticker-track-wrapper">
        <div className="ticker-track">
          {items.map((n, i) => (
            <span
              key={i}
              className="ticker-item"
              onClick={() => navigate(`/noticias/${n.id}`)}
            >
              {n.titulo}
              <span className="ticker-separator">◆</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
